import * as actionTypes from '../actions/actionTypes.js';
import updateFiltersFromSelections from '../helpers/updateFiltersFromSelections'
import { isEqual, uniqWith } from 'lodash'

export default (state, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_MAP :
      return {
        ...state,
        mapVisible: !state.mapVisible,
      };
    case actionTypes.SET_DATA :
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        dataMeta: action.payload.dataMeta,
        requestCounter: state.requestCounter + 1,
      };
    case actionTypes.SET_NOT_PAGINATED_DATA :
      return {
        ...state,
        notPaginatedData: action.payload.data,
        searchByMoveLoading: false,
      };
    case actionTypes.SET_NOT_PAGINATED_DATA_LOADING:
      return {
        ...state,
        searchByMoveLoading: action.payload.loading,
        notPaginatedData: action.payload.loading ? [] : [...state.notPaginatedData],
      };
    case actionTypes.SET_ORDER_BY :
      return {
        ...state,
        loading: true,
        page: 1,
        sortBy: action.payload.dropdownValue,
        sorts: [ action.payload.value ],
      };
    case actionTypes.SET_NEW_STATE :
      return {
        ...state,
        ...action.payload.state,
      };
    case actionTypes.SET_SEARCH_TERMS :
      return updateTerms(state, action)
    case actionTypes.SET_SELECTIONS :
      return updateSelections(state, action)
    case actionTypes.SET_FILTERS_LIST :
      return updateList(state, action)
    case actionTypes.SET_LOADING :
      return {
        ...state,
        loading: action.payload.value,
      };
    case actionTypes.SET_ERROR :
      return {
        ...state,
        error: action.payload.value,
      };
    case actionTypes.SET_PAGE :
      return {
        ...state,
        loading: true,
        page: action.payload.value,
      };
    case actionTypes.SET_PER_PAGE :
      return {
        ...state,
        page: 1,
        loading: true,
        per_page: action.payload.value,
      };
    case actionTypes.SET_VIEW :
      return {
        ...state,
        view: action.payload.value,
      };
    case actionTypes.SET_SEARCH_BY_MOVE :
      return {
        ...state,
        searchByMoveActive: action.payload.value,
        searchTerm: '',
      };
    case actionTypes.SET_MAP_DATA :
      return {
        ...state,
        radius: action.payload.radius,
        mapCenter: action.payload.mapCenter,
      };
    default:
      return state;
  }
};

function updateTerms(state, action) {

  if ( state.searchTerm === action.payload.data.value && state.searchType === action.payload.data.type ) {
    return {
      ...state,
    }
  }
  let sortBy = !state.searchTerm ? 'nearest' : state.sortBy
  let sorts =  !state.searchTerm ? [{
    'field': 'distance',
    'method': 'asc',
  }] : state.sorts

  if ( !action.payload.data.value && ( state.sortBy === 'nearest' || state.sortBy === 'farthest') ) {
    sortBy = 'newest'
    sorts = [{
			'field': 'venue_live',
			'method': 'desc',
    }]
  }

  return {
    ...state,
    page: 1,
    loading: true,
    searchTerm: action.payload.data.value,
    searchType: action.payload.data.type || 'restaurant',
    sortBy,
    sorts,
  };
}

function updateSelections(state, action) {
  let newSelections
  let term = state.searchTerm
  let sorts = state.sorts
  let sortBy = state.sortBy
  if ( action.payload.action === 'remove') {
    newSelections = state.selections.filter( selection => !isEqual(selection, action.payload.data) )
  } else if ( action.payload.action === 'replace') {
    let field
    if ( action.payload.data.filters ) {
      field = action.payload.data.filters[0].field
    } else {
      field = action.payload.data.field
    }
    const filteredSelections = state.selections.filter(selection => {
      const selectionField = selection.filters ? selection.filters[0].field : selection.field;
      return selectionField !== field
    })
    newSelections = [
      ...filteredSelections,
      action.payload.data,
    ]
  }
  else if ( action.payload.action === 'clearAll') {
    newSelections = []
    term = ''
    sortBy = 'newest'
    sorts = [{
			'field': 'venue_live',
			'method': 'desc',
    }]
  } else if ( action.payload.action === 'clearAllOfType') {
    let field
    if ( action.payload.data.filters ) {
      field = action.payload.data.filters[0].field
    } else {
      field = action.payload.data.field
    }
    const filteredSelections = state.selections.filter(selection => {
      const selectionField = selection.filters ? selection.filters[0].field : selection.field;
      return selectionField !== field
    })
    newSelections = [
      ...filteredSelections,
    ]
  } else {
    if ( action.payload.data.field === 'name' && state.selections.length ) {
      newSelections = [
        ...state.selections.filter(selection => selection.field !== 'name'),
        action.payload.data,
      ]
    } else {
      newSelections = [
        ...state.selections,
        action.payload.data,
      ]
    }
  }
  const unique = uniqWith([ ...newSelections ], isEqual);
  const newState = {
    ...state,
    loading: true,
    page: 1,
    selections: unique,
    searchTerm: term,
    sorts,
    sortBy,
  }
  return updateFiltersFromSelections(newState)
}

function updateList(state, action) {
  let newState = {}

  if ( action.payload.ambiences ) {
    newState['ambiences'] = {
      ...state.filters.ambiences,
      opened: (typeof action.payload.ambiences.opened !== 'undefined') ? action.payload.ambiences.opened : state.filters.ambiences.opened,
      list: action.payload.ambiences.list ? action.payload.ambiences.list : state.filters.ambiences.list,
    }
  }
  if ( action.payload.cuisines ) {
    newState['cuisines'] = {
      ...state.filters.cuisines,
      opened: (typeof action.payload.cuisines.opened !== 'undefined') ? action.payload.cuisines.opened : state.filters.cuisines.opened,
      list: action.payload.cuisines.list ? action.payload.cuisines.list : state.filters.cuisines.list,
    }
  }
  if ( action.payload.awards ) {
    newState['awards'] = {
      ...state.filters.awards,
      opened: (typeof action.payload.awards.opened !== 'undefined') ? action.payload.awards.opened : state.filters.awards.opened,
      list: action.payload.awards.list ? action.payload.awards.list : state.filters.awards.list,
    }
  }
  if ( action.payload.search ) {
    newState['search'] = {
      ...state.filters.search,
      opened: (typeof action.payload.search.opened !== 'undefined') ? action.payload.search.opened : state.filters.search.opened,
      value: action.payload.search.value ? action.payload.search.value : state.filters.search.value,
    }
  }
  if ( action.payload.privateDining ) {
    newState['privateDining'] = {
      ...state.filters.privateDining,
      opened: (typeof action.payload.privateDining.opened !== 'undefined') ? action.payload.privateDining.opened : state.filters.privateDining.opened,
      value: action.payload.privateDining.value ? action.payload.privateDining.value : state.filters.privateDining.value,
    }
  }
  if ( action.payload.clubOffers ) {
    newState['clubOffers'] = {
      ...state.filters.clubOffers,
      opened: (typeof action.payload.clubOffers.opened !== 'undefined') ? action.payload.clubOffers.opened : state.filters.clubOffers.opened,
      anyMeal: (typeof action.payload.clubOffers.anyMeal !== 'undefined') ? action.payload.clubOffers.anyMeal : state.filters.clubOffers.anyMeal,
      clubOffersOnly: (typeof action.payload.clubOffers.clubOffersOnly !== 'undefined') ? action.payload.clubOffers.clubOffersOnly : state.filters.clubOffers.clubOffersOnly,
      list: action.payload.clubOffers.list ? action.payload.clubOffers.list : state.filters.clubOffers.list,
    }
    if ( newState['clubOffers']['anyMeal'] ) {
      newState['clubOffers']['list'] = {
        'Breakfast': {},
        'Lunch': {},
        'Afternoon Tea': {},
        'Dinner': {},
      }
    }
  }
  if ( Object.keys(newState).length && isEqual(state.filters, newState.filters) ) {
    return state
  }
  return {
    ...state,
    page: 1,
    loading: true,
    filters: {
      ...state.filters,
      ...newState,
    },
  }
}
